import styled from "styled-components"

export const Buttons = styled.div`
  margin-right: 4px;

  .buttonCancel {
    border-radius: 5px !important;
    cursor: pointer !important;
  }

  .buttonSubmit {
    border-radius: 5px;
    margin-right: 4px !important;
  }
`;

export const Wrapper = styled.div`
  padding: 16px;
  padding-bottom: 6px;
  display: flex;
  flex-direction: row;
  background-color: ${({theme}) => theme.colors.surface.surface};

  .form {
    width: 100%;
    
    .inputNewName {
      width: 100%;

      input {
        background-color: ${({theme}) => theme.colors.secondary.secondary};
      }
    }
  }
`;
